import FormattedDate from './FormattedDate'

export default FormattedDate



// WEBPACK FOOTER //
// ./src/legacy/components/FormattedDate/index.js